import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../../../Components/Form";
import { MODULOS } from "../../../../../../Constants/Geral/Modulos";
import { useUserInfor } from "../../../../../../Context/User";
import { VincularDocumentoTemplateFormularioController } from "../../../../../../Controllers/Automacao/Formularios/ConfigTemplateFormulario/ConfigTemplateFormularioControllers";
import { ListarDocumentosTemplateController } from "../../../../../../Controllers/Geral/GestaoDeCadastros/DocumentosTemplate/DocumentosTemplateControllers";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";

interface ICriarConfiguracaoTemplateFormularioProps {
    then?: () => void;
    idFormulario: number;
}

interface ICriarConfiguracaoTemplateFormularioFormData {
    ID_DOCUMENTO_TEMPLATE: number;
    ID_MODULO: number;
    ID_CATEGORIA_ATENDIMENTO: number;
}

export default function CriarConfiguracaoTemplateFormulario(
    props: ICriarConfiguracaoTemplateFormularioProps
) {
    const { OrgInfor } = useUserInfor();

    const formMethods = useForm<ICriarConfiguracaoTemplateFormularioFormData>();
    const ID_MODULO = formMethods.watch("ID_MODULO");

    const { execute: handleSubmit, loading: adicionando } = useAsyncCallback(
        async (formData: ICriarConfiguracaoTemplateFormularioFormData) => {
            await VincularDocumentoTemplateFormularioController({
                ...formData,
                ID_FORMULARIO: props.idFormulario,
            }).then(() => {
                props.then?.();
            });
        }
    );

    return (
        <FormProvider {...formMethods}>
            <UnForm handleSubmit={handleSubmit} usingContext>
                <UnForm.LazySelect
                    name="ID_DOCUMENTO_TEMPLATE"
                    label="Documento de Template"
                    controller={ListarDocumentosTemplateController}
                    getDS={(dt) => dt.DS_DOCUMENTO}
                    getKeyValue={(dt) => dt.ID_DOCUMENTO_TEMPLATE}
                    registerOptions={{
                        required:
                            "Insira o template de documento usado para enviar e-mail",
                    }}
                ></UnForm.LazySelect>
                <UnForm.Select
                    name="ID_MODULO"
                    label="Módulo"
                    onChange={(e) => {
                        formMethods.setValue(
                            "ID_CATEGORIA_ATENDIMENTO",
                            undefined
                        );
                    }}
                    registerOptions={{
                        required: "Insira o módulo",
                    }}
                >
                    <option></option>
                    {OrgInfor.MODULOS?.map((mod) => (
                        <option value={mod.ID_MODULO}>
                            {MODULOS.ID(mod.ID_MODULO).DS_NOME}
                        </option>
                    ))}
                </UnForm.Select>
                <div className="mb-3">
                    <label>Categoria de Atendimento</label>
                    <UnForm.SelectCategoriaAtendimento
                        ID_MODULO={ID_MODULO}
                        name="ID_CATEGORIA_ATENDIMENTO"
                        allowClear
                    />
                </div>
                <UnForm.SubmitButton
                    icon={faPlus}
                    wrapperClassName="m-0 my-4"
                    className="w-100"
                    color="success"
                    loading={adicionando}
                    loadingSize="sm"
                >
                    Adicionar Configuração
                </UnForm.SubmitButton>
            </UnForm>
        </FormProvider>
    );
}
